import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

const TalentReviewSectionTitle = styled.h2`
	margin: 0;
	color: ${tokens.text.primary};
	font-family: ${tokens.typography.fontFamily};
	font-size: ${tokens.typography.sizes.h1}px;
	font-weight: ${500};
	line-height: ${tokens.typography.lineHeights.heading};
	white-space: nowrap;
`;

export default TalentReviewSectionTitle;
